import React, { FunctionComponent } from 'react';
import { graphql } from 'react-relay';
import { useLazyLoadQuery } from 'react-relay/hooks';
import { Center } from 'src/shared/globals';
import { T } from 'src/shared/helpers';
import NoImage from 'src/shared/svg/noImage';
import styled from 'styled-components';
import { Button } from '../../../../widgets/buttons';
import { ContainerBase } from '../../../../widgets/layouts';
import { FormControl } from '../../../../widgets/formControl';
import { PageSubtitle as PageDescription } from '../../../../widgets/headers';
import { newProductAction, useProductConfigurationChangeStep, useProductConfigurationState } from '../../state';
import { podDoneQuery } from './__generated__/podDoneQuery.graphql';

const Container = styled(ContainerBase)`
    max-width: 600px;
`;

const ProductImageContainer = styled.div`
    width: 200px;
    height: 200px;
    margin: 100px auto 30px;
    display: block;
    border: 1px #ddd solid;
`;

const ProductImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const ProductName = styled(Center)`
    margin-bottom: 100px;
    font-weight: 600;
`;

const PodDone: FunctionComponent<{}> = (props) => {
    const changeStep = useProductConfigurationChangeStep();
    const { state, dispatch } = useProductConfigurationState();

    const query = useLazyLoadQuery<podDoneQuery>(
        graphql`
            query podDoneQuery {
                ecommerceSettings {
                    ecommerceName
                    currencyCode
                }
            }
        `,
        {}
    );

    const woocomerceAlert = T._(
        `Important: the product will be created as "pending" in your WooCommerce.<br/>It takes about 30-45 minutes to have it published at your store.<br/>Do not publish it manually! We will inform you by email when ready.`,
        'Admin'
    );
    const alert = T._(
        `Creating product in the background. It may take up to a few minutes but don't need to wait,<br>we'll inform you as soon as the product is created at your store.`,
        'Admin'
    );

    const handleAddAnotherProductClick = () => {
        dispatch(newProductAction());
        changeStep('add-product', false);
    };

    return (
        <>
            <PageDescription
                dangerouslySetInnerHTML={{
                    __html: query.ecommerceSettings?.ecommerceName === 'WOO_COMMERCE' ? woocomerceAlert : alert
                }}
            />

            <Container>
                <ProductImageContainer>
                    {state.providerProduct?.imageUrl ? <ProductImage src={state.providerProduct?.imageUrl} /> : <NoImage />}
                </ProductImageContainer>

                <ProductName>{state.providerProduct?.name}</ProductName>

                <FormControl>
                    <Button onClick={handleAddAnotherProductClick}>{T._('Add another product', 'Admin')}</Button>
                </FormControl>
            </Container>
        </>
    );
};

export default PodDone;
